import React from "react";
import styles from './navbar.module.css';
import { NavLink } from "react-router-dom";

function Navbar() {

  return(
    <nav className={`${styles.navbar}`}>
      <NavLink to='/' className={({ isActive }) => isActive ? `${styles.link_first__active}` : `${styles.link_first}`}>
        Главная
      </NavLink>
      <NavLink to='/catalog' className={({ isActive }) => isActive ? `${styles.link__active}` : `${styles.link}`}>
        Каталог
      </NavLink>
      <NavLink to='/about' className={({ isActive }) => isActive ? `${styles.link__active}` : `${styles.link}`}>
        О компании
      </NavLink>
      <NavLink to='/contacts' className={({ isActive }) => isActive ? `${styles.link__active}` : `${styles.link}`}>
        Контакты
      </NavLink>
    </nav>
  );
}

export default Navbar;
